import React, { useMemo } from 'react';
import { isRichText, sanitizeRichText } from '../lib/richText';

interface RichTextProps {
  /** Description HTML, or an older plain-text description. */
  value: string;
  className?: string;
  style?: React.CSSProperties;
}

/** Shows a video description: sanitised formatting, or plain text with its line breaks. */
const RichText: React.FC<RichTextProps> = ({ value, className = '', style }) => {
  const html = useMemo(() => (isRichText(value) ? sanitizeRichText(value) : null), [value]);
  return html !== null ? (
    <div className={`airec-rich-text break-words ${className}`} style={style} dangerouslySetInnerHTML={{ __html: html }} />
  ) : (
    <p className={`whitespace-pre-line break-words ${className}`} style={style}>{value}</p>
  );
};

export default RichText;
